// extracted by mini-css-extract-plugin
module.exports = {"root":"EmptyMessage-root-8936ac34fcda4ec6e81c9231f497b669"};